import { render } from "./ModalWindow.vue?vue&type=template&id=2c067a44&scoped=true&ts=true"
import script from "./ModalWindow.vue?vue&type=script&lang=ts"
export * from "./ModalWindow.vue?vue&type=script&lang=ts"

import "./ModalWindow.vue?vue&type=style&index=0&id=2c067a44&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c067a44"]])

export default __exports__